import Observer from '../../core/classes/Observer';

class TranslationService extends Observer{

}

const translationService = new TranslationService(null);
export default translationService